import { call, put, takeLatest } from 'redux-saga/effects';
import request from '../../api/request';

function* getAllPaymentTypes() {
  try {
    yield put({
      type: 'FETCH_PAYMENT_TYPES_REQUESTING',
    });

    yield put({
      type: 'SHOW_LOADING',
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/payment-type`;
    const headers = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: 'FETCH_PAYMENT_TYPES_SUCCESS',
      value: response,
    });

  } catch (error) {
    yield put({
      type: 'SHOW_ALERT',
      value: {
        type: 'danger',
        title: 'Error al cargar',
        message: 'Error al cargar los tipos de pago',
      },
    });
    yield put({
      type: 'FETCH_PAYMENT_TYPES_FAILURE',
    });
  } finally {
    yield put({
      type: 'HIDE_LOADING',
    });
  }
}

export function* watchPaymentTypes() {
  yield takeLatest('FETCH_PAYMENT_TYPES_REQUEST', getAllPaymentTypes);
}
